/**
 * Calculates the percentage difference between two numbers.
 * Returns a decimal (e.g. 0.05 for 5%).
 * Always returns a **positive** value.
 *
 * @param original - The original or baseline value
 * @param compared - The new or compared value
 * @returns The relative difference as a decimal
 */
export const differenceInPercentage = (
  original: number,
  compared: number
): number => {
  if (original === 0) return 0;
  return Math.abs(original - compared) / original;
};
